module.exports = __webpack_public_path__ + "img/K6.a148ebe1.png";